import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRepeat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.333.667L14 3.333 11.333 6",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 1.333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 7.333V6a2.667 2.667 0 012.667-2.667H14M4.667 15.333L2 12.667 4.667 10",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 1.333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 8.667V10a2.667 2.667 0 01-2.667 2.667H2",
			stroke: "currentColor",
			fill: "none",
			strokeWidth: 1.333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export { SvgRepeat as ReactComponent };
